import { Link } from "gatsby";
import React from "react";
import BlogPostCard from "../components/BlogPostCard";
import Figure from "./Figure";

const serializers = {
  types: {
    mainImage: Figure,
    authorReference: ({ node }) => <span>{node.author.name}</span>,
    conceptReference: ({ node }) => <span>{node.concept.title}</span>,
    networkReference: ({ node }) =>
      node.network.ready ? (
        <Link to={`network/${node.network.slug.current}`}>{node.network.title}</Link>
      ) : (
        <span>{node.network.title}</span>
      ),
    postReference: ({ node }) =>
      node.post.publishedAt ? (
        <BlogPostCard postNode={node.post} />
      ) : (
        <span>{node.post.title}</span>
      ),
    sectorReference: ({ node }) => <span>{node.sector.title}</span>,
    roleReference: ({ node }) => <span>{node.role.title}</span>,
    systemParameterReference: ({ node }) => <span>{node.systemParameter.title}</span>,
    tokenReference: ({ node }) => <span>{node.token.title}</span>,
    industryReference: ({ node }) => <span>{node.industry.title}</span>
  }
};

export default serializers;
